// Italia
export default {
	status: {
		All: "Tutto",
		Pending: "In sospeso",
		Frozen: "Congelato",
		Completed: "Completato",
		Undone: "Non fatto"
	},
	TotalAmount: "Importo totale",
	Profit: "Profitto",
	Expire: "Scadere"
};
